module.exports = __webpack_public_path__ + "static/ai1-45dccab6bbd5eb77c7f06e47e653ab2f.jpg";